import React, { useEffect, useState } from 'react';
import './SectionCommety.scss';
import './../../sassStyles/base/_typography.scss';

import Commety from './../Commety/Commety';
import CommetyBody from './../CommetyBody/CommetyBody';

const SectionCommety = () => {
  const [committee, setCommittee] = useState([]);
  const [show, setShow] = useState(false);
  const [level, setLevel] = useState([]);
  const [agenda, setAgenda] = useState([]);
  const [descr, setDescr] = useState([]);
  const [vac, setVac] = useState([]);

  let committeeId;
  let committeeName;
  let committeeNameSec;
  let committeeNameThir;
  let committeeAgenda;
  let committeeAgendaSec;
  let committeeAgendaThir;
  let committeeLevel;
  let committeeLevelSec;
  let committeeLevelThir;
  let committeeDescription;
  let committeeDescriptionSec;
  let committeeDescriptionThir;
  let committeeVacancy;
  let committeeVacancySec;
  let committeeVacancyThir;

  useEffect(() => {
    fetch('http://localhost:8080/committees/committee')
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('Failed to fetch committees.');
        }
        return res.json();
      })
      .then((resData) => {
        setCommittee(resData);

        console.log('resData:', resData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (committee.committees) {
    committeeId = committee.committees[0]._id;
    committeeName = committee.committees[0].committeeName;
    committeeNameSec = committee.committees[1].committeeName;
    committeeNameThir = committee.committees[2].committeeName;
    committeeLevel = committee.committees[0].committeeLevel;
    committeeLevelSec = committee.committees[1].committeeLevel;
    committeeLevelThir = committee.committees[2].committeeLevel;
    committeeVacancy = committee.committees[0].committeeVacancy;
    committeeVacancySec = committee.committees[1].committeeVacancy;
    committeeVacancyThir = committee.committees[2].committeeVacancy;
    committeeAgenda = committee.committees[0].committeeAgenda;
    committeeAgendaSec = committee.committees[1].committeeAgenda;
    committeeAgendaThir = committee.committees[2].committeeAgenda;
    committeeDescription = committee.committees[0].committeeDescription;
    committeeDescriptionSec = committee.committees[1].committeeDescription;
    committeeDescriptionThir = committee.committees[2].committeeDescription;
  }

  const clickHandlerOne = () => {
    setShow(true);
    setLevel(committeeLevel[0]);
    setAgenda(committeeAgenda[0]);
    setVac(committeeVacancy[0]);
    setDescr(committeeDescription[0]);
  };

  const clickHandlerSec = () => {
    setLevel(committeeLevelSec[0]);
    setAgenda(committeeAgendaSec[0]);
    setVac(committeeVacancySec[0]);
    setDescr(committeeDescriptionSec[0]);
  };
  const clickHandlerThird = () => {
    setLevel(committeeLevelThir[0]);
    setAgenda(committeeAgendaThir[0]);
    setVac(committeeVacancyThir[0]);
    setDescr(committeeDescriptionThir[0]);
  };
  // const clickHandlerFour = () => {
  //   setLevel(committeeLevel[3]);
  //   setAgenda(committeeAgenda[3]);
  //   setVac(committeeVacancy[3]);
  //   setDescr(committeeDescription[3]);
  // };
  // const clickHandlerFive = () => {
  //   setLevel(committeeLevel[4]);
  //   setAgenda(committeeAgenda[4]);
  //   setVac(committeeVacancy[4]);
  //   setDescr(committeeDescription[4]);
  // };
  // const clickHandlerSix = () => {
  //   setLevel(committeeLevel[5]);
  //   setAgenda(committeeAgenda[5]);
  //   setVac(committeeVacancy[5]);
  //   setDescr(committeeDescription[5]);
  // };
  // const clickHandlerSev = () => {
  //   setLevel(committeeLevel[6]);
  //   setAgenda(committeeAgenda[6]);
  //   setVac(committeeVacancy[6]);
  //   setDescr(committeeDescription[6]);
  // };
  // const clickHandlerEigh = () => {
  //   setLevel(committeeLevel[7]);
  //   setAgenda(committeeAgenda[7]);
  //   setVac(committeeVacancy[7]);
  //   setDescr(committeeDescription[7]);
  // };

  return (
    <div className="section-commety" id="section-commety">
      <h2 className="section-commety__title heading-secondary"> Committees</h2>
      <div className="section-commety__item-box">
        <button onClick={clickHandlerOne} className="btn btn-commety">
          {committeeName}
        </button>
        <button onClick={clickHandlerSec} className="btn btn-commety">
          {committeeNameSec}
        </button>
        <button onClick={clickHandlerThird} className="btn btn-commety">
          {committeeNameThir}
        </button>
        {/* <button onClick={clickHandlerFour} className="btn btn-commety">
          {committeeName[3]}
        </button>
        <button onClick={clickHandlerFive} className="btn btn-commety">
          {committeeName[4]}
        </button>
        <button onClick={clickHandlerSix} className="btn btn-commety">
          {committeeName[5]}
        </button>
        <button onClick={clickHandlerSev} className="btn btn-commety">
          {committeeName[6]}
        </button>
        <button onClick={clickHandlerEigh} className="btn btn-commety">
          {committeeName[7]}
        </button> */}
      </div>
      {show ? (
        <CommetyBody
          level={level}
          vacancy={vac}
          agenda={agenda}
          description={descr}
        ></CommetyBody>
      ) : (
        ''
      )}
    </div>
  );
};

export default SectionCommety;
